export { default } from './FooterII';
